import { motion } from 'motion/react';
import { choices as fixtureChoices } from '../fixtures/uiKitFixtures';

const list = {
  visible: { transition: { staggerChildren: 0.07 } }
};

const itemEnterSpring = { type: 'spring', damping: 22, stiffness: 320 };

const item = {
  hidden: { opacity: 0, x: 14 },
  visible: { opacity: 1, x: 0, transition: itemEnterSpring }
};

/** Hover/tap on plain CSS transform — Motion whileHover over Live2D was costing ~10 FPS moving across rows. */
const choiceBtnClass =
  'flex w-full origin-center items-center gap-2.5 rounded-xl border px-5 py-3.5 text-left text-base font-medium leading-snug transition-transform duration-75 ease-out hover:scale-[1.01] active:scale-[0.99] motion-reduce:transform-none motion-reduce:hover:scale-100 motion-reduce:active:scale-100';

/**
 * @param {object} props
 * @param {{ id: string, label: string, tokenCost?: number, gift?: boolean }[]} [props.choices] — игровой режим
 * @param {(id: string) => void} [props.onChoose]
 * @param {number} [props.playerTokens] — баланс; при tokenCost &gt; баланса вызывается onInsufficientTokens
 * @param {() => void} [props.onInsufficientTokens]
 * @param {string | null} [props.sectionTitle] — заголовок над списком; `null` скрыть (оверлей визуала)
 */
export default function GameChoiceButtons({
  choices,
  onChoose,
  playerTokens,
  onInsufficientTokens,
  sectionTitle = 'Choices'
}) {
  const useFixture = !choices || choices.length === 0;
  const rows = useFixture ? fixtureChoices : choices;

  return (
    <motion.div
      className="flex w-full max-w-md flex-col gap-2.5 px-4 py-4"
      variants={list}
      initial="hidden"
      animate="visible"
    >
      {sectionTitle ? (
        <p className="mb-1 text-center text-[10px] font-semibold uppercase tracking-wide text-game-muted">
          {sectionTitle}
        </p>
      ) : null}
      {rows.map((c) => (
        <motion.div key={c.id} variants={item} className="w-full">
          <button
            type="button"
            className={`${choiceBtnClass} bg-game-surface text-game-text shadow-sm ${
              c.tokenCost
                ? 'border-game-accent/65 ring-2 ring-game-accent/30 ring-inset'
                : c.gift
                  ? 'border-white/22'
                  : 'border-white/18'
            }`}
            onClick={() => {
              if (useFixture) return;
              const cost = c.tokenCost;
              if (
                typeof cost === 'number' &&
                cost > 0 &&
                typeof playerTokens === 'number' &&
                playerTokens < cost
              ) {
                onInsufficientTokens?.();
                return;
              }
              onChoose?.(c.id);
            }}
          >
            <span className="min-w-0 flex-1">{c.label}</span>
            {c.tokenCost ? (
              <span className="shrink-0 rounded-md bg-game-accent px-2 py-0.5 text-xs font-bold text-game-accentText">
                {c.tokenCost} ◆
              </span>
            ) : null}
            {c.gift ? (
              <span className="shrink-0 text-lg" aria-hidden>
                🎁
              </span>
            ) : null}
          </button>
        </motion.div>
      ))}
    </motion.div>
  );
}
